export const NAME = 'hospitalIndemnity'

export const GET_HOSPITAL_INDEMNITY = 'clientBenefitsHospitalIndemnityGet'
export const POST_HOSPITAL_INDEMNITY = 'clientBenefitsHospitalIndemnityPost'
